import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import useLogout from '@hooks/useLogout';
import { compose, withStateHandlers } from 'recompose';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { userDataSelector } from '@selectors/global';

const getAbbreviated = (value) =>
  (value || '')
    .split(' ')
    .map((item) => (item ? item[0].toUpperCase() : ''))
    .join('');

const SidebarAccountSettingsWidget = ({ isOpen, toggle, userData }) => {
  const { logout } = useLogout();

  return (
    <SidebarAccountSettingsWidget.Wrapper>
      <div onClick={toggle} onKeyUp={toggle}>
        <SidebarAccountSettingsWidget.Circle>
          {getAbbreviated(userData.get('name'))}
        </SidebarAccountSettingsWidget.Circle>
      </div>

      <SidebarAccountSettingsWidget.Settings isOpen={isOpen}>
        <SidebarAccountSettingsWidget.Title>
          Account Settings
          <SidebarAccountSettingsWidget.Down onClick={toggle}>
            <i className="icon fa fa-angle-down" />
          </SidebarAccountSettingsWidget.Down>
        </SidebarAccountSettingsWidget.Title>

        <SidebarAccountSettingsWidget.Controls>
          <SidebarAccountSettingsWidget.Button onClick={logout}>
            Logout
          </SidebarAccountSettingsWidget.Button>
        </SidebarAccountSettingsWidget.Controls>

        <SidebarAccountSettingsWidget.Bottom>
          <SidebarAccountSettingsWidget.Logged>
            <SidebarAccountSettingsWidget.LoggedAs>
              LOGGED IN AS
            </SidebarAccountSettingsWidget.LoggedAs>
            <SidebarAccountSettingsWidget.Name>
              {userData.get('name')}
            </SidebarAccountSettingsWidget.Name>
            <SidebarAccountSettingsWidget.Name>
              {userData.get('office')}
            </SidebarAccountSettingsWidget.Name>
          </SidebarAccountSettingsWidget.Logged>

          <SidebarAccountSettingsWidget.Circle onClick={toggle}>
            {getAbbreviated(userData.get('name'))}
          </SidebarAccountSettingsWidget.Circle>
        </SidebarAccountSettingsWidget.Bottom>
      </SidebarAccountSettingsWidget.Settings>
    </SidebarAccountSettingsWidget.Wrapper>
  );
};

SidebarAccountSettingsWidget.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  userData: PropTypes.object,
};

SidebarAccountSettingsWidget.Wrapper = styled.div`
  width: 40px;
  height: 40px;
`;

SidebarAccountSettingsWidget.Circle = styled.span`
  display: flex;
  justify-content: center;
  width: 35px;
  height: 35px;
  text-align: center;
  font-size: 12px;
  line-height: 35px;
  font-weight: bold;
  color: #fff;
  background: ${(props) => props.theme.colors.purple};
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.colors.lightGray};
    transition: 0.3s;
  }
`;

SidebarAccountSettingsWidget.Settings = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: ${(props) => (props.isOpen ? '0' : '-500px')};
  transition: 0.3s all;
`;

SidebarAccountSettingsWidget.Title = styled.div`
  position: relative;
  background: ${(props) => props.theme.colors.purple};
  padding: 10px;
  color: #fff;
  font-family: Roboto, sans-serif;
  font-weight: normal;
  font-size: 14px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
`;

SidebarAccountSettingsWidget.Down = styled.div`
  position: absolute;
  top: 9px;
  right: 9px;
  font-size: 20px;
  cursor: pointer;
`;

SidebarAccountSettingsWidget.Controls = styled.div`
  display: flex;
  flex-direction: column;
  padding: 3px;
  background: transparent;
`;

SidebarAccountSettingsWidget.Button = styled.button`
  width: 100%;
  border: 1px solid #4353af;
  color: #4353af;
  padding: 5px;
  outline: none;
  background: #fff;
  transition: 0.3s;
  font-weight: 300;
  font-family: Roboto, sans-serif;
  cursor: pointer;

  &:hover {
    background: #bbd431;
    color: #4353af;
    border: 1px solid #fff;
    font-weight: 500;
  }
`;

SidebarAccountSettingsWidget.Bottom = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 7px;
  background: #cecece;
`;

SidebarAccountSettingsWidget.Logged = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  align-items: flex-end;
`;

SidebarAccountSettingsWidget.LoggedAs = styled.span`
  color: #333;
  line-height: 15px;
  text-align: right;
  font-family: Roboto, sans-serif;
  font-size: 13px;
  font-weight: 300;
`;

SidebarAccountSettingsWidget.Name = styled.span`
  color: ${(props) => props.theme.colors.purple};
  font-family: Roboto, sans-serif;
  font-size: 13px;
  line-height: 1;
  font-weight: 500;
`;

const withState = compose(
  connect(createStructuredSelector({ userData: userDataSelector }), {}),
  withStateHandlers(({ isOpen = false }) => ({ isOpen }), {
    toggle:
      ({ isOpen }) =>
      () => ({ isOpen: !isOpen }),
  }),
);

export default withState(SidebarAccountSettingsWidget);
